import Box from '@/common/components/Box';
import MaintenanceObjectiveHorizontal from '@/common/components/MaintenanceObjectiveHorizontal';
import { useMemo } from 'react';
import { AuctionEntryForwardingData } from '../../../../types/auctionEntry.type';
import ExecutionObjectiveActivities from './ExecutionObjectiveActivities';
import ExecutionObjectivePieces from './ExecutionObjectivePieces';

interface ExecutionEntryUpdateObjectiveAttributesProps {
  forwarding: AuctionEntryForwardingData | undefined
  dataUpdatedAt?: number
}

const ExecutionEntryUpdateObjectiveAttributes = ({
  forwarding,
  dataUpdatedAt,
}: ExecutionEntryUpdateObjectiveAttributesProps) => {
  const objectives = useMemo(() => {
    const objectives = forwarding?.directive_entry?.objectives

    objectives?.sort((a, b) => a.id.localeCompare(b.id))

    return objectives
  }, [dataUpdatedAt])

  const objectiveOffsets = useMemo(() => {
    let pieceOffset = 0
    let activityOffset = 0

    return objectives?.map((objective) => {
      const currentPieceOffset = pieceOffset
      const currentActivityOffset = activityOffset

      pieceOffset += objective.execution_pieces?.length || 0
      activityOffset += objective.execution_activities?.length || 0

      return {
        pieceStartIndex: currentPieceOffset,
        activityStartIndex: currentActivityOffset,
      }
    })
  }, [objectives]);

  return (
    <div className="flex flex-col gap-3">
      {objectives?.map((objective, index) => (
        <Box key={objective.id} className="flex flex-col gap-4 p-4 rounded-lg">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-4 flex-wrap justify-between">
            <MaintenanceObjectiveHorizontal
              systemDisplayName={objective.system.display_name}
              actionDisplayName={objective.action.display_name}
              partDisplayName={objective.part.display_name}
              actionDescription={objective.action.description}
            />
          </div>

          <div className="flex flex-col gap-4">
            <ExecutionObjectivePieces
              executionObjective={objective}
              pieceStartIndex={objectiveOffsets?.[index]?.pieceStartIndex || 0}
            />

            <ExecutionObjectiveActivities
              executionObjective={objective}
              activityStartIndex={objectiveOffsets?.[index]?.activityStartIndex || 0}
            />
          </div>
        </Box>
      ))}
    </div>
  )
}

export default ExecutionEntryUpdateObjectiveAttributes
